
import React from 'react';
import {View, Text, TouchableOpacity, Platform} from 'react-native';
import {createPortal} from 'react-dom';
import modalStyles from '../../style/boxChampCalculateModal';

const tone = {
  warn: '#FFC46B',
  warnBg: 'rgba(255,196,107,0.10)',
  body: '#E0E7EF',
};

export default function BoxChampReopenPrompt({box, onConfirm, onCancel}) {
  if (!box) return null;

  const dialog = (
    <View
      testID="boxchamp-reopen-overlay"
      style={[
        modalStyles.overlay,
        {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: 16,
          zIndex: 1200,
        },
      ]}>
      <View
        testID="boxchamp-reopen-prompt"
        style={[modalStyles.dialog, {width: '100%', maxWidth: 480}]}>
        <View style={modalStyles.header}>
          <Text style={modalStyles.headerTitle}>Reopen {box.name}?</Text>
        </View>

        <View style={modalStyles.body}>
          <View
            style={{
              backgroundColor: tone.warnBg,
              borderLeftWidth: 3,
              borderLeftColor: tone.warn,
              borderRadius: 6,
              paddingVertical: 10,
              paddingHorizontal: 12,
            }}>
            <Text
              testID="boxchamp-reopen-message"
              style={{
                fontFamily: 'Poppins_500Medium',
                fontSize: 14,
                color: tone.body,
              }}>
              {box.name} is already sealed. Removing this item means opening it
              again — continue?
            </Text>
          </View>
        </View>

        <View style={modalStyles.footer}>
          <TouchableOpacity
            testID="boxchamp-reopen-cancel"
            onPress={onCancel}
            style={modalStyles.cancelButton}>
            <Text style={modalStyles.cancelButtonText}>Keep it sealed</Text>
          </TouchableOpacity>
          <TouchableOpacity
            testID="boxchamp-reopen-confirm"
            onPress={onConfirm}
            style={modalStyles.queueButton}>
            <Text style={modalStyles.queueButtonText}>Open it and remove</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );

  return Platform.OS === 'web' && typeof document !== 'undefined'
    ? createPortal(dialog, document.body)
    : dialog;
}
